import { render, staticRenderFns } from "./Redemption.vue?vue&type=template&id=ce2be90e&scoped=true"
import script from "./Redemption.vue?vue&type=script&lang=js"
export * from "./Redemption.vue?vue&type=script&lang=js"
import style0 from "./Redemption.vue?vue&type=style&index=0&id=ce2be90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2be90e",
  null
  
)

export default component.exports